import BaseInvoker from '../../BaseInvoker'

const baseUrl = 'api/mobility/'
const baseInvoker = new BaseInvoker()

type SchedulesToReassign = {
  startDateTime: string
  transferScheduleId: number
}
interface ReassignBookingsProps {
  body: {
     schedules: SchedulesToReassign[]
     drivers: number[] 
    }
  callback: Function
  callerror: Function
}

export const postReassignBookings = ({
  body,
  callback,
  callerror,
}: ReassignBookingsProps) => {
  baseInvoker.post(`${baseUrl}reasign/bookings`, body, callback, callerror)
}
